import { render, staticRenderFns } from "./TopicoQuestaoDiscursiva.vue?vue&type=template&id=74f0b385&scoped=true"
import script from "./TopicoQuestaoDiscursiva.vue?vue&type=script&lang=js"
export * from "./TopicoQuestaoDiscursiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f0b385",
  null
  
)

export default component.exports